// extracted by mini-css-extract-plugin
module.exports = {"mark":"rkYe5J","gold":"tPRyCv","silver":"tkEwJp","bronze":"Ykwgs4"};